import { Injectable, OnDestroy } from '@angular/core';

import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Subject, BehaviorSubject, Subscription, Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { timer } from 'rxjs';


@Injectable()
export class DownloadService implements Resolve<any> {
    public _unsubscribeAll: Subject<any>;
    public _fuseConfig: FuseConfig;
    
    timer: Observable<number>;
    timerSubscription: Subscription;
    onDownloadsChanged: BehaviorSubject<any>;
    
    searchText: string;

    
    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        public _httpClient: HttpClient,
        private _authService: AuthService,
    ) {
        this._fuseConfig = fuseConfig;
        this._unsubscribeAll = new Subject();

        this.onDownloadsChanged = new BehaviorSubject({});

    }

    /**
     * Resolver
     *
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(): Observable<any> | Promise<any> | any
    {
        return new Promise((resolve, reject) => {
            Promise.all([
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    /**
     * Public methods
     */

    public listDownloads(companyId, lang: string = ''): Promise<any> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this._fuseConfig.api.url + '/portal/erp/' + companyId + '/doc/listing/' + lang)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        resolve(response);
                    }, reject);
        });

    }

    public downloadDocument(companyId: number, itemId: string, filename): Promise<any> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this._fuseConfig.api.url + '/portal/erp/' + companyId + '/doc/' + itemId + '/get', { responseType: 'blob' as 'json' })
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        resolve(response);
                        const dataType = response['type'];
                        const binaryData = [];
                        binaryData.push(response);
                        const downloadLink = document.createElement('a');
                        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
                        downloadLink.setAttribute('download', filename);
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                    }, reject);
        });
    }
}
